import {AxiosResponse} from "axios";
import axios from "../api-instance";
import ENDPOINTS from "../consts/endpoints";

export type IAttestationRepository = {
    getAttestations: Function;
    getAttestationsSubmission: Function;
    submitAttestation: Function;
    getStatistic: Function;
};

class AttestationRepository implements IAttestationRepository{
    private api = axios;
    private getData(response: AxiosResponse) {
        return response.data;
    }

    getAttestations(userId: string) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.PROFILES}/${userId}/attestations`).then(this.getData);
    }
    getAttestationsSubmission(attistationId: string) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.ATTESTATIONS}/${attistationId}/submission`).then(this.getData);
    }

    //@ts-expect-error
    submitAttestation(attistationId: string, answers) {
        this.api.setHeaders();
        return this.api.post(`${ENDPOINTS.ATTESTATIONS}/${attistationId}/submission`, answers).then(this.getData);
    }

    getStatistic(alias: string) {
        this.api.setHeaders();
        return this.api.get(`Statistics/${alias}/attestations`).then(this.getData);
    }

}

export default AttestationRepository;